import React, { useEffect, useState } from "react";
import Button from "./Button";
import rescheduleIcon from "../../assets/CalendarCheck.png";
import checkIcon from "../../assets/check2.png";
import { AEROMEGH_SERVICES, STATUS } from "../../appConstants";
import { quickRequestUpdateAPI, updateRequest } from "../../apis/requests";
import Loading from "../../ReusableFunctions/Loader";
import Popup from "../../ReusableFunctions/Popup";
import SelectComponent from "../../ReusableComponents/SelectComponent";
import cancelIcon from '../../assets/crossIcon.png';
import HoldIcon from '../../assets/OnHold.png';
import PaidIcon from '../../assets/paid.png';
import infoblackbg from "../../assets/Infoblackbg.svg";
export default function RequestDetailsHeader({
  request,
  setPopupState,
  onRequestUpdate,
  sprayingRequest,
  requestInvoiceRef,
  onResetStatus,
  selectedStatus,
  setSelectedStatus,
}) {

  const statusOrder = [
    STATUS.PLACED,
    STATUS.ACCEPTED,
    STATUS.OUT_FOR_SERVICE,
    STATUS.INPROGRESS,
    STATUS.COMPLETED,
    STATUS.PAID,
    STATUS.HOLD,
    STATUS.RESCHEDULED,
    STATUS.CANCELLED,
  ];

  const statusDropdownOptions = [];
  const [showPilotError, setShowPilotError] = useState(false);

  const isPilotErrorCondition = !(sprayingRequest.drone_pilot) && sprayingRequest.status === "Accepted";

  const [isCancelledByAdmin, setIsCancelledByAdmin] = useState(false);

  statusOrder.forEach((status) => {
    if (status === selectedStatus && status !== STATUS.RESCHEDULED) {
      statusDropdownOptions.push({
        label: selectedStatus,
        value: selectedStatus,
        isDisabled: true,
      });
    }
    // Accept
    if (status === STATUS.ACCEPTED && request?.status === STATUS.PLACED && request?.user?.id != null) {
      statusDropdownOptions.push({
        label: "Accept",
        value: STATUS.ACCEPTED,
        action: async () => {
          Loading.set(true);
          let { updatedRequest } = await quickRequestUpdateAPI(
            STATUS.ACCEPTED,
            undefined,
            sprayingRequest?.id,
            undefined,
            undefined
          );
          setSelectedStatus(STATUS.ACCEPTED);
          onRequestUpdate("Accepted", updatedRequest);
        },
        isDisabled: false,
      })
    }
    // On Hold
    else if (status === STATUS.HOLD && request?.user?.id != null && [STATUS.ACCEPTED, STATUS.RESCHEDULED, STATUS.OUT_FOR_SERVICE, STATUS.INPROGRESS].includes(sprayingRequest?.status)) {
      statusDropdownOptions.push({
        label: "On Hold",
        value: STATUS.HOLD,
        action: () => {
          setSelectedStatus(STATUS.HOLD)
          setPopupState((prev) => ({
            ...prev,
            hold: true,
          }));
        },
        isDisabled: false,
      })
    }
    // Reschedule
    else if (status === STATUS.RESCHEDULED && request?.user?.id != null && [STATUS.ACCEPTED, STATUS.HOLD, STATUS.OUT_FOR_SERVICE, STATUS.INPROGRESS, STATUS.RESCHEDULED].includes(request?.status) &&
          !statusDropdownOptions.some(opt => opt.value === STATUS.RESCHEDULED && !opt.isDisabled)          
    ) {
      statusDropdownOptions.push({
        label: "Reschedule",
        value: STATUS.RESCHEDULED,
        action: () => {
          setSelectedStatus(STATUS.RESCHEDULED)
          setPopupState((prev) => ({
            ...prev,
            reschedule: true,
          }));
        },
        isDisabled: false,
      })
    }
    // Out for Service
    else if (status === STATUS.OUT_FOR_SERVICE && request?.user?.id != null && [STATUS.ACCEPTED, STATUS.RESCHEDULED, STATUS.HOLD, ].includes(sprayingRequest?.status)) {
      statusDropdownOptions.push({
        label: "Out For Service",
        value: STATUS.OUT_FOR_SERVICE,
        action: async () => {
          if(isPilotErrorCondition || !sprayingRequest.drone_pilot) {
            Popup.alert("Assign pilot", "Please assign a pilot to proceed!", "ERROR");
            return;
          }
          Loading.set(true);
          const invoice = requestInvoiceRef.current?.getInvoice();
          let data = await updateRequest(
            {
              ...request,
              ...invoice,
              applied_coupons: invoice.applied_coupons,
              applied_discounts: [
                {
                  discount_type: "dsp_request_discount",
                  discount: Number(invoice.total_dsp_discount_percentage),
                  discounted_amount: invoice.total_discounted_amount_via_dsp,
                },
              ],
              status: STATUS.OUT_FOR_SERVICE,
            },
            AEROMEGH_SERVICES.SPRAYING
          );
          setSelectedStatus(STATUS.OUT_FOR_SERVICE)
          onRequestUpdate("OutForService", data.updatedRequest);
        },
        isDisabled: false,
      })
    }
    // In Progress
    else if (status === STATUS.INPROGRESS && request?.user?.id != null && [STATUS.RESCHEDULED, STATUS.ACCEPTED, STATUS.HOLD, STATUS.OUT_FOR_SERVICE].includes(sprayingRequest?.status)) {
      statusDropdownOptions.push({
        label: "In Progress",
        value: STATUS.INPROGRESS,
        action: async () => {
          if (isPilotErrorCondition || !sprayingRequest.drone_pilot) {
            Popup.alert("Assign pilot", "Please assign a pilot to proceed!", "ERROR");
            return;
          }
          Loading.set(true);
          const invoice = requestInvoiceRef.current?.getInvoice();
          let data = await updateRequest(
            {
              ...request,
              ...invoice,
              applied_coupons: invoice.applied_coupons,
              applied_discounts: [
                {
                  discount_type: "dsp_request_discount",
                  discount: Number(invoice.total_dsp_discount_percentage),
                  discounted_amount: invoice.total_discounted_amount_via_dsp,
                },
              ],
              status: STATUS.INPROGRESS,
            },
            AEROMEGH_SERVICES.SPRAYING
          );
          setSelectedStatus(STATUS.INPROGRESS);
          onRequestUpdate("InProgress", data.updatedRequest);
        },
        isDisabled: false,
      })
    }
    // Completed
    else if (status === STATUS.COMPLETED && request?.user?.id != null && ![STATUS.PLACED, STATUS.CANCELLED, STATUS.PAID, STATUS.COMPLETED].includes(sprayingRequest?.status)) {
      statusDropdownOptions.push({
        label: "Completed",
        value: STATUS.COMPLETED,
        action: () => {
          if (isPilotErrorCondition || !sprayingRequest.drone_pilot) {
            Popup.alert("Assign pilot", "Please assign a pilot to proceed!", "ERROR");
            return;
          }
          setSelectedStatus(STATUS.COMPLETED)
          setPopupState((prev) => ({
            ...prev,
            complete: true,
          }));
        },
        isDisabled: false,
      })
    }
    // Paid
    else if (status === STATUS.PAID && request?.user?.id != null && [STATUS.COMPLETED].includes(sprayingRequest?.status)) {
      statusDropdownOptions.push({
        label: "Paid",
        value: STATUS.PAID,
        action: async () => {
          Loading.set(true);
          const invoice = requestInvoiceRef.current?.getInvoice();
          let data = await updateRequest(
            {
              ...request,
              ...invoice,
              applied_coupons: invoice.applied_coupons,
              applied_discounts: [
                {
                  discount_type: "dsp_request_discount",
                  discount: Number(invoice.total_dsp_discount_percentage),
                  discounted_amount: invoice.total_discounted_amount_via_dsp,
                },
              ],
              status: STATUS.PAID,
            },
            AEROMEGH_SERVICES.SPRAYING
          );
          setSelectedStatus(STATUS.PAID);
          onRequestUpdate("Paid", data.updatedRequest);
        },
        isDisabled: false,
      })
    }
    // Cancel
    else if (status === STATUS.CANCELLED && request?.user?.id != null && ![STATUS.COMPLETED, STATUS.PAID, STATUS.CANCELLED].includes(request?.status)) {
      statusDropdownOptions.push({
        label: "Cancel",
        value: STATUS.CANCELLED,
        action: () => {
          setSelectedStatus(STATUS.CANCELLED)
          setPopupState((prev) => ({
            ...prev,
            cancel: true,
          }));
        },
        isDisabled: false,
      })
    }
  });
  
  // Handle Dropdown Selection
  const handleStatusChange = async (selectedValue) => {
    const selected = statusDropdownOptions.find(opt => opt.value === selectedValue);
    if (selected && selected.action) {
      try {
        await selected.action();
      }
      catch (err) {
        Loading.set(false);
        console.error(err);
        Popup.alert("ERROR", "Something went wrong", "ERROR");
      }
    }
  }

  useEffect(() => {
    setSelectedStatus(request?.status);
  }, [request?.status]);

  useEffect(() => {
    const lastStatus = request?.status_history?.[request?.status_history?.length - 1];
    if (lastStatus?.updated_status === STATUS.CANCELLED && lastStatus?.updated_by === 'Admin') {
      setIsCancelledByAdmin(true);
    } else {
      setIsCancelledByAdmin(false);
    }
  }, [request]);

  return (
    <div className="flex justify-between items-center  px-4 py-5 border-b  border-b-[#D9D9D9] ">
      <h4 className="font-manrope font-[700] ml-[8px] text-[18px] text-[#1E1E1E]">
        Request Details
      </h4>
      <div className="flex gap-4 items-center">
        <div className="mr-10 flex gap-4 items-center">
          <div>
          {isCancelledByAdmin &&
            (<span className="border px-4 py-1 rounded-lg border-gray-400 bg-[#3B3B3B1A] flex justify-center text-sm">
                <img src={infoblackbg} alt="info_image" className="pe-1 w-5 h-5" /> order no longer available
            </span>)
          }
          </div>
        </div>
        
        {request?.user?.id == null ? (
          <div
            style={{
              color: "crimson",
              maxWidth: "400px",
              wordWrap: "break-word",
              lineHeight: 1.1,
              fontSize: "13px",
            }}
          >
            Request cannot be modified as the user has deleted their account.
          </div>
        ) : null}

        {
          request?.user?.id != null && ![STATUS.CANCELLED, STATUS.PAID].includes(sprayingRequest?.status) &&
          <div className="flex items-center">
            <p className="me-3">Status : </p>
              <SelectComponent
                list={statusDropdownOptions}
                onChange={(status) => 
                    handleStatusChange(status.value)
                }
                isDisabled={false}
                controlStyle={{ height: "40px", width: "200px", minHeight: "20px", border: "1px solid black", color: "hsl(0deg 0% 20% / 64%)" }}
                value={selectedStatus ? { value: selectedStatus, label: selectedStatus } : null}
              />
            </div>
        }
      </div>
    </div>
  );
}
